import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#171717", contrastText: "#ffffff" },
    secondary: { main: "#a77d2e", contrastText: "#ffffff" },
    warning: { main: "#a77d2e" },
    background: { default: "#f5f5f3", paper: "#ffffff" },
    text: { primary: "#171717", secondary: "#666666" },
    divider: "#e5e5e2",
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: 'Arial, "Helvetica Neue", sans-serif',
    h1: { fontSize: "1.75rem", fontWeight: 750, letterSpacing: "-0.025em" },
    h2: { fontSize: "1.25rem", fontWeight: 700, letterSpacing: "-0.015em" },
    h3: { fontSize: "1.05rem", fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 700 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { minHeight: 44, borderRadius: 9, boxShadow: "none" },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { minHeight: 44 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { border: "1px solid #e8e8e5", boxShadow: "none" },
      },
    },
  },
});

export default theme;
